import { render, staticRenderFns } from "./prompt-version-cancel.vue?vue&type=template&id=0e182088"
var script = {}
import style0 from "./prompt-version-cancel.vue?vue&type=style&index=0&id=0e182088&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports